import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type EmailDomain from "./EmailDomain";

@Model()
class AllowedSenderEmailAddress extends ApplicationRecord {
  static jsonapiType = "allowed_sender_email_addresses";

  @Attr() emailAddress: string;

  @BelongsTo() EmailDomain: EmailDomain;

  @Attr() emailDomainId: number;

  @Attr() label: string;
}

export default AllowedSenderEmailAddress;
